import { AssetMarketplace } from '../../../components/marketplace';
import type { MarketplaceAsset } from '../../../types/marketplace';

export interface ToolPanelProps {
  assets: MarketplaceAsset[];
  /** 挂载 / 解绑工具。 */
  onToggle: (asset: MarketplaceAsset) => void;
}

/** 工具维度面板：工具橱窗（挂载 / 解绑）。 */
export default function ToolPanel({ assets, onToggle }: ToolPanelProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h3 style={{ margin: 0 }}>工具橱窗</h3>
      </div>
      <AssetMarketplace
        assets={assets}
        initialType="tool"
        hideTypeFilter
        title=""
        applyLabel="挂载"
        removeLabel="解绑"
        onToggle={onToggle}
      />
    </div>
  );
}
